module.exports = __webpack_public_path__ + "img/11-active.87f2e5ee.svg";